// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Poskusite znova z uporabo celotnega datuma, kot je ta: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Skupina',
  chart_labelSeries: () => 'Serija',
  chart_labelValue: () => 'Vrednost',
  checkboxSet_requiredMessageDetail: () => 'Zahtevano',
  checkbox_requiredMessageDetail: () => 'Zahtevano',
  close: () => 'Zapri',
  collection_noData: () => 'Ni podatkov za prikaz.',
  collection_selectAllRows: () => 'Izbira vseh vrstic',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Izbira vrstice ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Ni razvrstljivo',
  collection_sortEnabled: () => 'Razvrstljivo',
  confirmation: () => 'Potrditev',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' od ' + p['totalCount'],
  dataVisualization_noData: () => 'Ni podatkov za prikaz',
  dataVisualization_stateSelected: () => 'Izbrano',
  dataVisualization_stateUnselected: () => 'Neizbrano',
  error: () => 'Napaka',
  expandableList_expandCollapseInstructionText: () =>
    'Za razširitev in strnitev uporabite puščične tipke',
  expandableList_groupCollapse: () => 'Strnjeno',
  expandableList_groupExpand: () => 'Razširjeno',
  filePicker_addFiles: () => 'Dodaj datoteke',
  filePicker_dropzonePrimaryText: () => 'Povlecite in spustite',
  filePicker_dropzoneSecondaryText: () => 'Izberite datoteko ali jo spustite sem',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Izberite ali spustite datoteke sem',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Ne morete nalagati datotek tega tipa: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Naložite po eno datoteko naenkrat',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Ne morete nalagati datotek tipa ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'neznano',
  formControl_clear: () => 'Počisti',
  formControl_day: () => 'Dan',
  formControl_helpAvailable: () => 'Na voljo je pomoč',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Dosegli ste omejitev, ki je ' +
    ((
      {
        one: new Intl.NumberFormat('sl').format(p['CHARACTER_LIMIT']) + ' znak',
        two: new Intl.NumberFormat('sl').format(p['CHARACTER_LIMIT']) + ' znaka',
        few: new Intl.NumberFormat('sl').format(p['CHARACTER_LIMIT']) + ' znake'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('sl').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('sl').format(p['CHARACTER_LIMIT']) + ' znakov') +
    '.',
  formControl_loading: () => 'Nalaganje',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maksimalna dolžina, ki je ' + p['MAX_LENGTH'] + ', je presežena.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Preostali znaki: ' + p['CHARACTER_COUNT'] + '.',
  formControl_month: () => 'Mesec',
  formControl_readOnly: () => 'Samo za branje',
  formControl_requiredMessageDetail: () => 'Vnesite vrednost.',
  formControl_year: () => 'Leto',
  gantt_labelDate: () => 'Datum',
  gantt_labelEnd: () => 'Konec',
  gantt_labelLabel: () => 'Oznaka',
  gantt_labelRow: () => 'Vrstica',
  gantt_labelStart: () => 'Začetek',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Ni najdenega ujemajočega se odseka.',
  indexer_keyboardInstructionText: () => 'Za izbiro vrednosti pritisnite tipko Enter.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Med ' + p['FROM_SECTION'] + ' in ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Dvakrat tapnite in zadržite za vstop v način kretenj, nato pa za prilagajanje vrednosti povlecite gor ali dol.',
  info: () => 'Informacije',
  inputDateMask_date_cleared: () => 'Datum čiščenja',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Prazno',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'llll',
  inputNumber_converterParseError: () => 'Vnesite številko.',
  inputNumber_decrease: () => 'Zmanjšaj',
  inputNumber_increase: () => 'Povečaj',
  inputPassword_hidden: () => 'Geslo je skrito',
  inputPassword_hide: () => 'Skrij geslo',
  inputPassword_show: () => 'Prikaži geslo',
  list_suggestion: () => 'Predlog',
  messageToast_allMessagesClosed: () => 'Vsa toast obvestila so zaprta.',
  message_close: () => 'Zapri',
  message_confirmation: () => 'Uspeh',
  message_error: () => 'Napaka',
  message_info: () => 'Informacije',
  message_navigationFromMessagesRegion: () =>
    'Vstopanje v področje sporočil. Pritisnite F6 za krmarjenje nazaj do elementa, ki je bil v fokusu pred tem.',
  message_navigationToMessagesRegion: () =>
    'Področje sporočil ima nova sporočila. Pritisnite F6 za krmarjenje do najnovejšega področja sporočil.',
  message_warning: () => 'Opozorilo',
  noData_message: () => 'Ni elementov za prikaz',
  overflowItemLabel: () => 'Več zavihkov',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'V teku',
  radio_helpForRadio: () => 'Pomoč za izbirni gumb',
  radio_requiredMessageDetail: () => 'Izberite vrednost.',
  selectMultiple_apply: () => 'Dodeli',
  selectMultiple_back: () => 'Nazaj',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Za odstranitev izbrane vrednosti pritisnite tipko Backspace ali Delete.',
  selectMultiple_selectedValues: () => 'Izbrane vrednosti',
  selectMultiple_showSelectedValues: () => 'Prikažite samo izbrane vrednosti.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Izbrane vrednosti: ' + p['VALUE_COUNT'] + '.',
  select_addToList: () => 'Dodaj na seznam',
  select_addToListAvailable: () => 'Na voljo je dodajanje na seznam',
  select_moreSearchOptions: () => 'Več možnosti iskanja',
  select_moreSearchOptionsAvailable: () => 'Na voljo je več možnosti iskanja',
  select_noMatchesFound: () => 'Ni ustreznih zadetkov.',
  select_oneMatchFound: () => 'Najden je en zadetek',
  select_requiredMessageDetail: () => 'Izberite vrednost.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => 'Najdeni zadetki: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Najdeni zadetki: ' + p['TOTAL_SIZE'] + ' ali več',
  selector_selected: () => 'Potrditveno polje je označeno',
  selector_unselected: () => 'Potrditveno polje ni označeno',
  tabBarNavigationList_removeCueText: () => 'Odstranljivo',
  timeComponent_tooltipZoomIn: () => 'Povečava',
  timeComponent_tooltipZoomOut: () => 'Pomanjšava',
  train_current: () => 'Trenutno',
  train_message_type: () => 'Tip sporočila',
  train_not_visited: () => 'Ni obiskano',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Korak ' + p['currentStep'] + ' od ' + p['numberOfSteps'],
  train_visited: () => 'Obiskano',
  userAssistance_learnMore: () => 'Več o tem',
  userAssistance_required: () => 'Zahtevano',
  viz_drillable: () => 'Omogoča vrtanje',
  warn: () => 'Opozorilo'
};
export default bundle;
